import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{sq-field-select\n  content=this.content\n  value=this.value\n  prompt=this.prompt\n  disabled=this.disabled\n  selectClassNames=this.selectClassNames\n  onChange=this.onChange\n}}", {
  moduleName: "@dashboard/shared-ui/components/sq-field-select-state.hbs"
});